<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        TIME ATTENDANCE REPORT
                    </h1>
                </v-col>
            </v-row>
        </v-container>
        <v-card>
            <v-card-title>
                <v-row v-if="filter.searchable == 'Y'">
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-if="filter.branchs.length > 0"
                    >
                        <!-- @change="getEmployee()" -->
                        <v-autocomplete
                            :items="filter.branchs"
                            v-model="search.branch_id"
                            item-text="branch_name"
                            item-value="branch_id"
                            label="Branch"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-if="filter.costcenters.length > 0"
                    >
                        <!-- @change="getEmployee()" -->
                        <v-autocomplete
                            :items="filter.costcenters"
                            v-model="search.cost_center_id"
                            item-text="cost_center_name"
                            item-value="cost_center_id"
                            label="Cost Center"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-if="filter.departments.length > 0"
                    >
                        <!-- @change="getEmployee()" -->
                        <v-autocomplete
                            :items="filter.departments"
                            v-model="search.department_id"
                            item-text="department_name"
                            item-value="department_id"
                            label="Department"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-if="filter.positions.length > 0"
                    >
                        <!-- @change="getEmployee()" -->
                        <v-autocomplete
                            :items="filter.positions"
                            v-model="search.position_id"
                            item-text="position_name"
                            item-value="position_id"
                            label="Position"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            v-model="modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Date range"
                                    readonly
                                    v-on="on"
                                    dense
                                    :rules="dateR"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="search.date"
                                range
                                @change="get_date()"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-if="filter.attranges.length > 0"
                    >
                        <!-- @change="getEmployee()" -->
                        <v-autocomplete
                            :items="filter.attranges"
                            v-model="search.att_range_id"
                            item-text="att_range_name"
                            item-value="att_range_id"
                            label="Time Att. Range"
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field
                            v-model="search.search"
                            placeholder="Search"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col ols="12" sm="3" md="3">
                        <v-btn
                            color="primary"
                            class="ml-3"
                            small
                            @click="getEmployee()"
                            >Search</v-btn
                        >
                        <v-btn
                            color="warning"
                            class="ml-3"
                            small
                            dark
                            @click="reset()"
                            >Reset</v-btn
                        >
                    </v-col>
                    <v-col cols="12" class="mar-t-20">
                        <v-btn
                            v-if="team_name == 'HR'"
                            rounded
                            small
                            :color="chk_export == false ? 'green accent-3' : ''"
                            class="ml-3"
                            @click="export_data()"
                            :disabled="data.length == 0"
                        >
                            <img
                                v-if="chk_export == true"
                                src="../../assets/all/Loading.gif"
                                style="width: 5%"
                            />
                            <span v-if="chk_export == false">
                                <v-icon
                                    color="teal darken-4"
                                    small
                                    class="mr-1 mb-1"
                                    >mdi-file-excel</v-icon
                                >
                                <span>export raw</span>
                            </span>
                        </v-btn>

                        <v-btn
                            v-if="team_name == 'HR'"
                            rounded
                            small
                            :color="
                                chk_export2 == false ? 'green accent-3' : ''
                            "
                            class="ml-3"
                            @click="export_data2()"
                            :disabled="data.length == 0"
                        >
                            <img
                                v-if="chk_export2 == true"
                                src="../../assets/all/Loading.gif"
                                style="width: 5%"
                            />
                            <span v-if="chk_export2 == false">
                                <v-icon
                                    color="teal darken-4"
                                    small
                                    class="mr-1 mb-1"
                                    >mdi-file-excel</v-icon
                                >
                                <span>export summary</span>
                            </span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-row :class="filter.searchable == 'N' ? 'mar-t-20' : ''">
                <v-col cols="12" v-if="chk_search == true">
                    <v-progress-linear
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                </v-col>
                <v-col cols="12" v-for="(row, index) in data" :key="index">
                    <v-chip small color="primary" class="ml-2 mb-1">{{
                        row.date + " " + row.date_char
                    }}</v-chip>
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th rowspan="2" class="text-center">#</th>
                                    <th rowspan="2" class="text-center">
                                        Name
                                    </th>
                                    <th rowspan="2" class="text-center">
                                        {{
                                            team_name == "HR"
                                                ? "Position - Branch"
                                                : "Branch"
                                        }}
                                    </th>
                                    <th colspan="4" class="text-center">IN</th>
                                    <th colspan="4" class="text-center">OUT</th>
                                </tr>
                                <tr class="col-tr-1">
                                    <th class="text-center">Time</th>
                                    <th class="text-center" width="7%">Img</th>
                                    <th class="text-center" width="10%">
                                        Device/GPS
                                    </th>
                                    <th class="text-center">Remark</th>
                                    <th class="text-center">Time</th>
                                    <th class="text-center" width="7%">Img</th>
                                    <th class="text-center" width="10%">
                                        Device/GPS
                                    </th>
                                    <th class="text-center">Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(r, i) in row.emp" :key="i">
                                    <td class="text-center">{{ i + 1 }}.</td>
                                    <td>
                                        <span>{{
                                            r.emp_id + " " + r.emp_name
                                        }}</span>
                                    </td>
                                    <td>
                                        {{
                                            team_name == "HR"
                                                ? r.position_name +
                                                  " - " +
                                                  r.branch_name
                                                : r.branch_name
                                        }}
                                    </td>
                                    <td class="text-center">
                                        <span :class="r.in_color">{{
                                            r.in_time
                                        }}</span>
                                    </td>
                                    <td class="text-center">
                                        <div
                                            v-if="r.in_img"
                                            class="images cur-p"
                                            v-viewer="{ movable: false }"
                                        >
                                            <img
                                                :src="url_pic + r.in_img"
                                                class="image-cso"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <v-btn
                                            x-small
                                            fab
                                            v-if="r.in_device == 'pc'"
                                            color="light-blue lighten-4"
                                        >
                                            <v-icon small
                                                >mdi-desktop-mac</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            x-small
                                            fab
                                            v-if="r.in_device == 'mobile'"
                                            color="green accent-1"
                                        >
                                            <v-icon small>
                                                mdi-cellphone
                                            </v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="r.in_time"
                                            x-small
                                            :class="r.in_device ? 'ml-2' : ''"
                                            rounded
                                        >
                                            <v-icon
                                                small
                                                color="green accent-2"
                                                class="mr-1"
                                                >mdi-google-maps</v-icon
                                            >
                                            {{ r.in_branch_name }}
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        {{ r.in_remark }}
                                    </td>
                                    <!-- out -->
                                    <td class="text-center">
                                        {{ r.out_time }}
                                    </td>
                                    <td class="text-center">
                                        <div
                                            v-if="r.out_img"
                                            class="images cur-p"
                                            v-viewer="{ movable: false }"
                                        >
                                            <img
                                                :src="url_pic + r.out_img"
                                                class="image-cso"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <v-btn
                                            x-small
                                            fab
                                            v-if="
                                                r.out_device == 'pc' &&
                                                r.out_time
                                            "
                                            color="light-blue lighten-4"
                                        >
                                            <v-icon small
                                                >mdi-desktop-mac</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            x-small
                                            fab
                                            v-if="
                                                r.out_device == 'mobile' &&
                                                r.out_time
                                            "
                                            color="green accent-1"
                                        >
                                            <v-icon small
                                                >mdi-cellphone-iphone</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            v-if="r.out_time"
                                            x-small
                                            :class="r.out_device ? 'ml-2' : ''"
                                            rounded
                                        >
                                            <v-icon
                                                small
                                                color="green accent-2"
                                                class="mr-1"
                                                >mdi-google-maps</v-icon
                                            >
                                            {{ r.out_branch_name }}
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        {{ r.out_remark }}
                                    </td>
                                </tr>

                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>
        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color: #fff">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {
        ...mapState(["isLoading"]),
        dateRangeText() {
            this.search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.search.date.join(" ~ ")
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.getFilter()
    },
    data() {
        return {
            chk_export: false,
            team_name: localStorage.team_name,
            tk: null,
            search: {
                branch_id: "",
                att_range_id: "",
                search: "",
                cost_center_id: "",
                department_id: "",
                position_id: "",
                date: [],
            },
            modal: false,
            data: [],
            filter: [],
            dateR: [(v) => !!v || "Dates is required"],
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/time-att/image/`,
            chk_search: false,
            chk_export2: false,
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        async getFilter() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/hr/filter`
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url, this.tk)
                // console.log(data)
                this.filter = data
                this.search.date = [data.date.start, data.date.end]
                this.mutateIsLoading()
                if (data.searchable == "N") {
                    this.getEmployee()
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getEmployee() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/att/show-report`
            this.chk_search = true

            this.mutateIsLoading()
            await axios
                .post(url, this.search, options)
                .then((response) => {
                    this.data = response.data
                    this.chk_search = false
                    this.mutateIsLoading()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reset() {
            this.search = {
                branch_id: "",
                att_range_id: "",
                search: "",
                cost_center_id: "",
                department_id: "",
                position_id: "",
                date: [],
            }
        },
        get_map(lat, lng) {
            let url_map = "https://www.google.com/search?q=" + lat + "," + lng
            window.open(url_map, "_blank")
        },
        async export_data() {
            // this.search
            this.chk_export = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/att/export-report`,
                method: "POST",
                responseType: "blob",
                data: this.search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async export_data2() {
            // this.search
            this.chk_export2 = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/att/export-report-summary`,
                method: "POST",
                responseType: "blob",
                data: this.search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export2 = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },
}
</script>
<style scoped>
.image-cso {
    /* height: 10; */
    width: 40px;
    cursor: pointer;
    /* margin: 5px; */
    display: inline-block;
}
.fix-fbb {
    font-weight: bold;
}
</style>
